import { ProtocolContentData } from "../../protocol";
export default class TimeZone extends ProtocolContentData {
    tz;
    constructor(tz) {
        super();
        this.tz = tz;
    }
}
//# sourceMappingURL=TimeZone.js.map